import { forwardRef, useEffect, useState } from "react";
import AppFormEditor from "../../../AppFormEditor";
import { AppPartType } from "../../../types";
import styled from "styled-components";

const PlaceHoder = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: calc(100% - 10px);
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

type PropsType = {
  appPart: AppPartType;
  isNotAllowDrop?: boolean;
};

const Table = forwardRef<AppPartType, PropsType>(
  ({ appPart, isNotAllowDrop }, selectedAppPartRef) => {
    return (
      <AppFormEditor
        layout={appPart.children}
        parentAppPart={appPart}
        ref={selectedAppPartRef}
        tableLayout
        compactType="horizontal"
        rowHeight={25}
        maxRows={5}
        isNotAllowDrop={isNotAllowDrop}
        extra={
          (appPart.children || []).length === 0 ? (
            <PlaceHoder>
              {isNotAllowDrop
                ? "ここに追加することはできません"
                : "ここにはドラッグドロップするフィルードとなる"}
            </PlaceHoder>
          ) : undefined
        }
      />
    );
  },
);
Table.displayName = "Table";

export default Table;
